import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MetricConfigurationVault from './metric-configuration-vault-model'
import {
  CreateMetricConfigurationVaultAsync,
  DeleteMetricConfigurationVaultAsync,
  LoadMetricConfigurationVaultsAsync,
} from './metricConfigurationVault-thunk'
const initialState: metricConfigurationVaultSliceState = {
  metricConfigurationVault: [],
  selected_metricConfigurationVault: '',
  is_loading_metricConfigurationVault: false,
  is_creating_metricConfigurationVault: false,
  is_deleting_metricConfigurationVault: false,
}
export interface metricConfigurationVaultSliceState {
  metricConfigurationVault: MetricConfigurationVault[]
  selected_metricConfigurationVault?: string
  is_loading_metricConfigurationVault: boolean
  is_creating_metricConfigurationVault: boolean
  is_deleting_metricConfigurationVault: boolean
}
export const metricConfigurationVaultSlice = createSlice({
  name: 'metricConfigurationVault',
  initialState,
  reducers: {
    setSelectedmetricConfigurationVault: (state, action) => {
      state.selected_metricConfigurationVault = action.payload
    },
    clearStatemetricConfigurationVault: (state) => {
      state.metricConfigurationVault = []
      state.is_loading_metricConfigurationVault = false
      state.is_creating_metricConfigurationVault = false
      state.is_deleting_metricConfigurationVault = false
    },
    mergemetricConfigurationVault: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricConfigurationVault = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricConfigurationVault = merge(
            state.metricConfigurationVault,
            payload,
          ) as any
        }
      }
    },

    add_metricConfigurationVault: (state, action) => {
      if (action.payload) {
        state.metricConfigurationVault = [
          ...state.metricConfigurationVault,
          action.payload,
        ]
      }
    },
    set_metricConfigurationVault: (state, action) => {
      let { key, value, id } = action.payload
      state.metricConfigurationVault = state.metricConfigurationVault.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricConfigurationVaultsAsync.pending, (state) => {
      state.is_loading_metricConfigurationVault = true
    })
    builder.addCase(
      LoadMetricConfigurationVaultsAsync.fulfilled,
      (state, action) => {
        state.is_loading_metricConfigurationVault = false
        if (action.payload) {
          state.metricConfigurationVault = action.payload
        }
      },
    )
    builder.addCase(LoadMetricConfigurationVaultsAsync.rejected, (state) => {
      state.is_loading_metricConfigurationVault = false
    })
    builder.addCase(CreateMetricConfigurationVaultAsync.pending, (state) => {
      state.is_creating_metricConfigurationVault = true
    })
    builder.addCase(CreateMetricConfigurationVaultAsync.fulfilled, (state) => {
      state.is_creating_metricConfigurationVault = false
    })
    builder.addCase(CreateMetricConfigurationVaultAsync.rejected, (state) => {
      state.is_creating_metricConfigurationVault = false
    })
    builder.addCase(DeleteMetricConfigurationVaultAsync.pending, (state) => {
      state.is_deleting_metricConfigurationVault = true
    })
    builder.addCase(
      DeleteMetricConfigurationVaultAsync.fulfilled,
      (state, action) => {
        state.is_deleting_metricConfigurationVault = false
        if (state.metricConfigurationVault) {
          state.metricConfigurationVault =
            state.metricConfigurationVault.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(DeleteMetricConfigurationVaultAsync.rejected, (state) => {
      state.is_deleting_metricConfigurationVault = false
    })
  },
})

export const {
  clearStatemetricConfigurationVault,
  setSelectedmetricConfigurationVault,
  set_metricConfigurationVault,
  mergemetricConfigurationVault,
  add_metricConfigurationVault,
} = metricConfigurationVaultSlice.actions

export const get_metricConfigurationVault =
  (id?: string) =>
  (state: {
    metricConfigurationVault: {
      metricConfigurationVault: MetricConfigurationVault[]
    }
  }): MetricConfigurationVault | null => {
    let temp = state?.metricConfigurationVault?.metricConfigurationVault?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricConfigurationVault?.metricConfigurationVault[0] || null
  }
export const get_selected_metricConfigurationVault = (state: {
  metricConfigurationVault: metricConfigurationVaultSliceState
}): MetricConfigurationVault | null => {
  let id = state?.metricConfigurationVault?.selected_metricConfigurationVault
  let temp = state?.metricConfigurationVault?.metricConfigurationVault?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricConfigurationVault = (state: {
  metricConfigurationVault: {
    metricConfigurationVault: MetricConfigurationVault[]
  }
}): MetricConfigurationVault[] => {
  let temp = state?.metricConfigurationVault?.metricConfigurationVault
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricConfigurationVault_busy = (state: {
  metricConfigurationVault: metricConfigurationVaultSliceState
}) => {
  return (
    state?.metricConfigurationVault.is_deleting_metricConfigurationVault ||
    state?.metricConfigurationVault.is_loading_metricConfigurationVault ||
    state?.metricConfigurationVault.is_creating_metricConfigurationVault
  )
}
export const is_deleting_metricConfigurationVault_busy = (state: {
  metricConfigurationVault: metricConfigurationVaultSliceState
}) => {
  return state?.metricConfigurationVault.is_deleting_metricConfigurationVault
}
export const is_loading_metricConfigurationVault_busy = (state: {
  metricConfigurationVault: metricConfigurationVaultSliceState
}) => {
  return state?.metricConfigurationVault.is_loading_metricConfigurationVault
}
export const is_creating_metricConfigurationVault_busy = (state: {
  metricConfigurationVault: metricConfigurationVaultSliceState
}) => {
  return state?.metricConfigurationVault.is_creating_metricConfigurationVault
}

export default metricConfigurationVaultSlice.reducer
